import { getCompanyContactDataById } from '../companyContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ICompanyMSContact } from '@/types/company/models'

const companyMSContactListData = undefined as unknown as ICompanyMSContact[]

export const getCompanyMSContactListData = getListDataFunctionFactory<
  ICompanyMSContact[]
>({
  listData: companyMSContactListData,
  storageKey: 'companymscontacts',
  getStartingListData: getStartingCompanyMSContactListData,
})

export async function getCompanyMSContactListDataByCMSId(id: TEntityId) {
  const listData = await getCompanyMSContactListData()
  return listData.filter(
    (omsct: ICompanyMSContact) => omsct.companyMasterService.id === id
  )
}

export async function getCompanyMSContactDataById(
  id: TEntityId
): Promise<ICompanyMSContact | undefined> {
  const listData = await getCompanyMSContactListData()
  return listData.find((omsc: ICompanyMSContact) => omsc.id === id)
}

export async function getStartingCompanyMSContactListData(): Promise<
  ICompanyMSContact[]
> {
  return [
    {
      id: 'XXOMSC0001',
      hrid: 'OMSC0001',
      companyMasterService: {
        id: 'XXOMS0005',
        label: 'DIA',
      },
      contact: await getCompanyContactDataById('XXCCT0017')!,
      splitFraction: null,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
